import { jt, t } from 'ttag'
import styled from 'styled-components'

import { SO30S, WHITE } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'

const ContentBox = styled.div`
  background-color: ${SO30S};
  color: ${WHITE};
  width: 50%;
  padding: 15px;
`
const Interests = ({ interests }) => {
  const firstInterest =
    interests?.length > 0 ? <b key="int1">{interests[0]?.name}</b> : 'n/a'
  const secondInterest =
    interests?.length > 1 ? <b key="int2">{interests[1]?.name}</b> : 'n/a'
  const thirdInterest =
    interests?.length > 2 ? <b key="int3">{interests[2]?.name}</b> : null
  const twoIntSummary = jt`This means people who work in this occupation generally have ${firstInterest} interests, but also prefer ${secondInterest} environments.`
  const threeIntSummary = jt`This means people who work in this occupation generally have ${firstInterest} interests, but also prefer ${secondInterest} and ${thirdInterest} environments.`
  const code = <b key="intcode">{interests?.map(i => i.name.charAt(0)).join('')}</b>

  return (
    <ContentBox>
      <Heading level="3" color={WHITE}>{t`Interests`}</Heading>
      <Text color={WHITE}>
        {jt`People who work in this occupation generally have the interest code: ${code}.`}
      </Text>
      <Text color={WHITE}>{thirdInterest ? threeIntSummary : twoIntSummary} </Text>
    </ContentBox>
  )
}

export { Interests }
